module.exports = __webpack_public_path__ + "static/img/11.2680d67.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/11.png
// module id = bV4B
// module chunks = 0